export const SET_STAKEHOLDERS = 'SET_STAKEHOLDERS'
export const ADD_STAKEHOLDER = 'ADD_STAKEHOLDER'
export const UPDATE_STAKEHOLDER = 'UPDATE_STAKEHOLDER'

